import { render, staticRenderFns } from "./CbsIndicatorAccess.vue?vue&type=template&id=06e4f4ec&scoped=true"
import script from "./CbsIndicatorAccess.vue?vue&type=script&lang=js"
export * from "./CbsIndicatorAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e4f4ec",
  null
  
)

export default component.exports